"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductIndicators = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var ProductIndicators = exports.ProductIndicators = function ProductIndicators(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  if (props.itemIndicators === undefined || !props.itemIndicators || !props.itemIndicators.length) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "wbm-item-indicators"
  }, props.itemIndicators.filter(function (icon) {
    return icon.itemIdentifier.id === props.itemIdentifier.id && icon.itemIdentifier.unitId === props.itemIdentifier.unitId;
  }).sort(function (a, b) {
    return b.iconPriority - a.iconPriority;
  }).map(function (indicatorIcon, index) {
    var iconSize = 15;
    if (props.iconSize) {
      iconSize = props.iconSize;
    }
    return /*#__PURE__*/_react["default"].createElement("img", {
      src: indicatorIcon.iconUrl,
      alt: indicatorIcon.iconAltText,
      title: indicatorIcon.iconAltText,
      height: iconSize,
      width: indicatorIcon.iconWidth / indicatorIcon.iconHeight * iconSize,
      className: "wbm-item-indicator",
      key: props.itemIdentifier.id + props.itemIdentifier.unitId + " indicator: " + index
    });
  }));
};
//# sourceMappingURL=productIndicators.js.map